import { _GROUPS } from "@/store/_PERMISSIONS"

// -- FIELDS
const _FIELDS = [
  {
    label: "Nome",
    name: "nome",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "Descrição",
    name: "descricao",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: []
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Nome",
    align: "left",
    value: "nome"
  },
  {
    text: "Descrição",
    align: "left",
    value: "descricao"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const DADIVA = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default DADIVA
